module.exports = __webpack_public_path__ + "38cfea326a3afb06009d177ceded0350.png";